import { useMemo } from 'react';

export const useAvailabilityDetailReportRows = (dataList) => {
  return useMemo(() => {
    return Object.entries(dataList || {}).map(([title, value]) => {
      return {
        name: title,
        items: Object.entries(value).map(([partOfDay, value]) => {
          return {
            name: partOfDay,
            items: Object.entries(value).reduce((result, [key, value]) => {
              result.push({
                name: `${key} (${partOfDay})`,
                items: value.map((item) => {
                  const [unit, employee, availability] = item;
                  return { unit, employee, availability };
                }),
                footer: [`Total: ${value.length}`],
              });
              return result;
            }, []),
          };
        }),
      };
    });
  }, [dataList]);
};

export default useAvailabilityDetailReportRows;
